import { render, staticRenderFns } from "./WorkspaceAvatar.vue?vue&type=template&id=01877e9e&scoped=true"
import script from "./WorkspaceAvatar.vue?vue&type=script&lang=ts"
export * from "./WorkspaceAvatar.vue?vue&type=script&lang=ts"
import style0 from "./WorkspaceAvatar.vue?vue&type=style&index=0&id=01877e9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01877e9e",
  null
  
)

export default component.exports